import { FC } from 'react';

import {
  DirectoryRecordForm,
  type DirectoryRecordFormProps,
  type FormContentProps,
} from 'modules/directory/common/components';

import { DirectoryRecordLayout, FormHeaderActionsProps } from '../components';

export interface DirectoryRecordViewProps
  extends DirectoryRecordFormProps,
    FormContentProps,
    FormHeaderActionsProps {
  directoryName?: string;
  submitLoading: boolean;
}

export const DirectoryRecordView: FC<DirectoryRecordViewProps> = ({
  directoryName,
  initialValues,
  record,
  fieldsConfig,
  isArchived,
  isCanEdit,
  onArchive,
  onDearchive,
  onSubmit,
  submitLoading,
  validationSchema,
}) => (
  <DirectoryRecordForm
    initialReadOnly
    initialValues={initialValues}
    validationSchema={validationSchema}
    onSubmit={onSubmit}
  >
    <DirectoryRecordLayout
      directoryName={directoryName}
      fieldsConfig={fieldsConfig}
      isArchived={isArchived}
      isCanEdit={isCanEdit}
      record={record}
      submitLoading={submitLoading}
      onArchive={onArchive}
      onDearchive={onDearchive}
    />
  </DirectoryRecordForm>
);
